export enum FileUploaderView {
  Photo,
  Video,
  Bulk,
  Gif,
  All,
  Inactive,
}
